export default __webpack_public_path__ + "static/media/poi_fireStationForest.c8cc2c47.svg";